import { Card, Col, List, Modal, Row, Spin, Tooltip } from 'antd';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { deleteInArray, DropdownAction, errorCatch, GET, JSXMap, makeFormData, POST, POSTFormData, QueryDetail, QueryOrder, QueryParam, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import { ExclamationCircleOutlined, SettingOutlined, UploadOutlined, UserOutlined } from '@ant-design/icons';
import User from '../../../common/User';
import AddUserInfo from '../../forms/AddUserInfo';
import LoadUserInfo from '../../forms/LoadUserInfo';
import PageLayout from '../../components/PageLayout';
import { replace } from 'lodash';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { MaxIcon } from '../../../common/Tool';
var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function FederationadministratorManagementUserinfo(props) {
    const classes = useStyles();
    const { auth } = props;

    const filters = () => [
        // {
        //     label: "Идентификатор",
        //     name: "ID",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "user.lastname",
            sort: true,
            filter: true,
            // filtered: "Штотланд"
            sorted: true
        },
        {
            name: "user.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "user.patronymic",
            sort: true,
            filter: true,
        },

        {
            name: "user.email",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "user.phone",
            sort: true,
            filter: true,
        },
        {
            name: "user.gender",
            sort: true,
            filter: true,
            display: (o) => o.name,
        },
        {
            label: "Дата создания",
            name: "createdAt",
            type: "date",
            sort: true,
            filter: true,
        },
        {
            name: "user.maxchatid",
            sort: true,
            filter: true,
            label:"Связан с MAX",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: { data: [
                    { ID: 1, name: "Да" },
                    { ID: 2, name: "Нет" },
                ] },
                type: "many-one",
            },
            queryComparer: (value, item) => {
                if(value == 1){
                    return "nnu"
                } else if(value == 2){
                    return "nu"
                }
                return ""
            }
        },
        {
            name: "user.tgchatid",
            sort: true,
            filter: true,
            label:"Связан с телеграм",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: { data: [
                    { ID: 1, name: "Да" },
                    { ID: 2, name: "Нет" },
                ] },
                type: "many-one",
            },
            queryComparer: (value, item) => {
                if(value == 1){
                    return "nnu"
                } else if(value == 2){
                    return "nu"
                }
                return ""
            }
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Пользователь</div>
                <div>Город</div>
            </div>),
            // label: "Город",
            name: "user.city",
            sort: true,
            filter: true,
            display: (o) => o.name,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Тех. инф.</div>
                <div>Город</div>
            </div>),
            // label: "Город",
            name: "city",
            sort: true,
            filter: true,
            display: (o) => o.name,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Тех. инф.</div>
                <div>Город (внутр.)</div>
            </div>),
            // label: "Город (внутр.)",
            name: "cityVnutr",
            sort: true,
            filter: true,
            display: (o) => o.name,
        },
        {
            name: "is.vk",
            alias: "user.vk",
            sort: true,
            filter: true,
            label:"Связан с VK",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: { data: [
                    { ID: 1, name: "Да" },
                    { ID: 2, name: "Нет" },
                ] },
                type: "many-one",
            },
            queryComparer: (value, item) => {
                if(value == 1){
                    return "nnu"
                } else if(value == 2){
                    return "nu"
                }
                return ""
            }
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Пользователь</div>
                <div>VK</div>
            </div>),
            // label: "VK",
            name: "user.vk",
            sort: true,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Тех. инф.</div>
                <div>VK</div>
            </div>),
            // label: "VK",
            name: "vk",
            sort: true,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Тех. инф.</div>
                <div>VK (внутр.)</div>
            </div>),
            // label: "VK (внутр.)",
            name: "vkVnutr",
            sort: true,
            filter: true,
        },

        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                {/* <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div> */}
                <div>Тип пользователя</div>
            </div>),
            name: "user.vseTipiPolzovatelei.tipPolzovatelya",
            display: (o) => o.opisanie,
            additionalFilter: [
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("opisanie", "ASC"),
                QueryParam("w-in-ID", "18,21,22,23"),
            ],
            sort: false,
            filter: true,
        },

        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div>
                <div>Школа федерации</div>
            </div>),
            name: "user.vseTipiPolzovatelei.shkola",

            mode: "dialog",
            modal: { width: "700px", zIndex: 1031 },
            relation: {
                uiFilter: () => [
                    {
                        label: "Дата регистрации",
                        name: "dataRegistratsii",
                        type: "date",
                        filterType: "range",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Название",
                        name: "nazvanieShkoliTantsev",
                        sort: true,
                        filter: true
                    },
                    {
                        label: "Региональное отделение",
                        name: "regionalnoeOtdelenie",
                        filterType: "group",
                        display: (o) => o.nazvanie,
                        sort: true,
                        filter: true
                    },
                ],
                displayString: (item) => {
                    return item.nazvanieShkoliTantsev + ", " + item?.regionalnoeOtdelenie?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>
                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                <span style={{ fontWeight: "600" }}>{item.nazvanieShkoliTantsev}</span>
                            </div>
                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                <span>{item?.regionalnoeOtdelenie?.nazvanie}</span>
                            </div>
                        </div>
                    )
                },
                reference: { object: "ShkoliFederatsii", property: "ID" },
                type: "many-one",
            },
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 18),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanieShkoliTantsev", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div>
                <div>Региональное отделение</div>
            </div>),
            name: "user.vseTipiPolzovatelei.shkola.regionalnoeOtdelenie",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 18),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div>
                <div>Дата регистрации</div>
            </div>),
            name: "user.vseTipiPolzovatelei.shkola.dataRegistratsii",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 18),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            filterType: "range",
            sort: false,
            filter: true,
        },

        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                {/* <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div> */}
                <div>Организатор</div>
            </div>),
            name: "user.vseTipiPolzovatelei.organizator",

            mode: "dialog",
            modal: { width: "700px", zIndex: 1031 },
            relation: {
                uiFilter: () => [
                    {
                        label: "Дата регистрации",
                        name: "dataRegistratsii",
                        type: "date",
                        filterType: "range",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Название",
                        name: "nazvanie",
                        sort: true,
                        filter: true
                    },
                    {
                        label: "Региональное отделение",
                        name: "regionalnoeOtdelenie",
                        filterType: "group",
                        display: (o) => o.nazvanie,
                        sort: true,
                        filter: true
                    },
                ],
                displayString: (item) => {
                    return item.nazvanie + ", " + item?.regionalnoeOtdelenie?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>
                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                <span style={{ fontWeight: "600" }}>{item.nazvanie}</span>
                            </div>
                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                <span>{item?.regionalnoeOtdelenie?.nazvanie}</span>
                            </div>
                        </div>
                    )
                },
                reference: { object: "OrganizatoriFederatsii", property: "ID" },
                type: "many-one",
            },
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 23),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Организатор</div>
                <div>Региональное отделение</div>
            </div>),
            name: "user.vseTipiPolzovatelei.organizator.regionalnoeOtdelenie",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 23),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Организатор</div>
                <div>Дата регистрации</div>
            </div>),
            name: "user.vseTipiPolzovatelei.organizator.dataRegistratsii",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 23),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            filterType: "range",
            sort: false,
            filter: true,
        },

        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                {/* <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div> */}
                <div>Преподаватель</div>
            </div>),
            name: "user.vseTipiPolzovatelei.prepodavatel",

            mode: "dialog",
            modal: { width: "700px", zIndex: 1031 },
            relation: {
                uiFilter: () => [
                    {
                        label: "Дата регистрации",
                        name: "dataRegistratsii",
                        type: "date",
                        filterType: "range",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Региональное отделение",
                        name: "regionalnoeOtdelenie",
                        filterType: "group",
                        display: (o) => o.nazvanie,
                        sort: true,
                        filter: true
                    },
                ],
                displayString: (item) => {
                    return item.user.lastname + " " + item.user.firstname + ", " + item?.regionalnoeOtdelenie?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>
                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                <span style={{ fontWeight: "600" }}>{item.user.lastname + " " + item.user.firstname}</span>
                            </div>
                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                <span>{item?.regionalnoeOtdelenie?.nazvanie}</span>
                            </div>
                        </div>
                    )
                },
                reference: { object: "PrepodavateliFederatsii", property: "ID" },
                type: "many-one",
            },
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 21),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("user.lastname", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Преподаватель</div>
                <div>Региональное отделение</div>
            </div>),
            name: "user.vseTipiPolzovatelei.prepodavatel.regionalnoeOtdelenie",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 21),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Преподаватель</div>
                <div>Дата регистрации</div>
            </div>),
            name: "user.vseTipiPolzovatelei.prepodavatel.dataRegistratsii",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 21),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            filterType: "range",
            sort: false,
            filter: true,
        },

        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                {/* <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Владелец школы</div> */}
                <div>Судья</div>
            </div>),
            name: "user.vseTipiPolzovatelei.sudya",

            mode: "dialog",
            modal: { width: "700px", zIndex: 1031 },
            relation: {
                uiFilter: () => [
                    {
                        label: "Дата регистрации",
                        name: "dataRegistratsii",
                        type: "date",
                        filterType: "range",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Региональное отделение",
                        name: "regionalnoeOtdelenie",
                        filterType: "group",
                        display: (o) => o.nazvanie,
                        sort: true,
                        filter: true
                    },
                ],
                displayString: (item) => {
                    return item.user.lastname +" "+item.user.firstname + ", " + item?.regionalnoeOtdelenie?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>
                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                <span style={{ fontWeight: "600" }}>{item.user.lastname +" "+item.user.firstname}</span>
                            </div>
                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                <span>{item?.regionalnoeOtdelenie?.nazvanie}</span>
                            </div>
                        </div>
                    )
                },
                reference: { object: "SudiFederatsii", property: "ID" },
                type: "many-one",
            },
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 22),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("user.lastname", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Судья</div>
                <div>Региональное отделение</div>
            </div>),
            name: "user.vseTipiPolzovatelei.sudya.regionalnoeOtdelenie",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 22),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>Судья</div>
                <div>Дата регистрации</div>
            </div>),
            name: "user.vseTipiPolzovatelei.sudya.dataRegistratsii",
            additionalFilter: [
                QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 22),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
                QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
                QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            ],
            filterType: "range",
            sort: false,
            filter: true,
        },
        {
            label: (<div style={{ lineHeight: "1.25em" }}>Группа рассылки</div>),
            name: "user.polzovateliGruppiPolzovatel.gruppa",
            // additionalFilter: [
            //     QueryParam("w-eq-user.vseTipiPolzovatelei.tipPolzovatelya", 22),
            //     QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentZapisi", 0),
            //     QueryParam("w-nnu-user.vseTipiPolzovatelei.dokumentPodtverzhdeniya", 0),
            //     QueryParam("w-nu-user.vseTipiPolzovatelei.dokumentOtmeniZapisi", 0)
            // ],
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: false,
            filter: true,
        },

    ];

    const replaceVk = (o) => {
        var a = o;
        a = replace(a, "https://vk.com/", "");
        a = replace(a, "http://vk.com/", "");
        a = replace(a, "vk.com/", "");
        return a;
    }

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-10`} style={{ minWidth: "25px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-8`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }} rowSpan={2}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Пользователь</div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "30px", backgroundColor: "white" }}>
                                    <Tooltip title="Max">
                                        <div className="bg bg-grey" style={{ minWidth: "30px" }}>
                                            <MaxIcon width={14} height={14} color="#4096ff" />
                                        </div>
                                    </Tooltip>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "30px", backgroundColor: "white" }}>
                                    <Tooltip title="Telegram">
                                        <div className="bg bg-grey" style={{ minWidth: "30px" }}>
                                            <i className="fa fa-telegram"></i>
                                        </div>
                                    </Tooltip>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "100px", backgroundColor: "white" }}>
                                    <Tooltip title="ВКонтакте">
                                        <div className="bg bg-grey" style={{ minWidth: "100px" }}>
                                            <i className="fa fa-vk"></i>
                                        </div>
                                    </Tooltip>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "130px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "130px" }}>
                                        Город
                                    </div>
                                </th>


                                <th className={`height-10`} style={{ minWidth: "250px", backgroundColor: "white" }}>
                                    <div className="bg bg-blue" style={{ minWidth: "250px" }}>
                                        Владелец школы
                                    </div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "250px", backgroundColor: "white" }}>
                                    <div className="bg bg-orange" style={{ minWidth: "250px" }}>
                                        Организатор
                                    </div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "250px", backgroundColor: "white" }}>
                                    <div className="bg bg-green" style={{ minWidth: "250px" }}>
                                        Преподаватель
                                    </div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "250px", backgroundColor: "white" }}>
                                    <div className="bg bg-red" style={{ minWidth: "250px" }}>
                                        Судья
                                    </div>
                                </th>


                                <th className={`height-10`} style={{ minWidth: "240px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "240px" }}>
                                        Комментарий
                                    </div>
                                </th>

                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, idx) => {
                                var shkola = item?.user?.vseTipiPolzovatelei?.filter(e => !!e.shkolaID);
                                var organizator = item?.user?.vseTipiPolzovatelei?.filter(e => !!e.organizatorID);
                                var prepodavatel = item?.user?.vseTipiPolzovatelei?.filter(e => !!e.prepodavatelID);
                                var sudya = item?.user?.vseTipiPolzovatelei?.filter(e => !!e.sudyaID);

                                return (<tr key={idx}>
                                    <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={(e) => { e.stopPropagation() }}>
                                        <DropdownAction
                                            placement="bottomLeft"
                                            style={{ padding: "0" }}
                                            button={() => (
                                                <div className={`bg bg-grey pointer`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                                                    <i className="fa fa-bars" style={{ fontSize: "11px" }}></i>
                                                </div>
                                            )}
                                            items={modelActions(item, idx)?.map((e, idx) => ({
                                                key: e.key || idx,
                                                auth: auth,
                                                mode: "MenuItem",
                                                object: item,
                                                collection: collection,
                                                setCollection: setCollection,
                                                ...e
                                            }))} />
                                    </td>
                                    <td className={`fixed height-5`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey light-30 border-transparent" style={{ textAlign: "left", height: "100%" }}>
                                            <User item={item?.user} />
                                            {/* <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div> */}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "40px", maxWidth: "40px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "center", height: "100%", minWidth: "40px", maxWidth: "40px" }}>
                                            <div>{(item?.user?.maxchatid) ? <span style={{ fontWeight: "bold" }}>Да</span> :
                                                <span style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>Нет</span>}</div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "40px", maxWidth: "40px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "center", height: "100%", minWidth: "40px", maxWidth: "40px" }}>
                                            <div>{(item?.user?.tgchatid) ? <span style={{ fontWeight: "bold" }}>Да</span> :
                                                <span style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>Нет</span>}</div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "center", height: "100%", minWidth: "100px", maxWidth: "100px" }}>
                                            {(!item?.user?.vk && !item?.vk && !item?.vkVnutr) && <div>
                                                <span style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>Нет</span>
                                            </div>}
                                            {(item?.user?.vk) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    <UserOutlined style={{ color: "#1890ff", fontSize: "12px", paddingRight: "3px" }} />
                                                    <Tooltip
                                                        title={<div>
                                                            <div style={{
                                                                textAlign: "left",
                                                                textWrap: "nowrap",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                fontSize: "12px",
                                                                fontWeight: "lighter"
                                                            }}>
                                                                <span>Пользовательская информация</span>
                                                            </div>
                                                            <div>id{item?.user?.vk}</div>
                                                        </div>}>
                                                        id{item?.user?.vk}
                                                    </Tooltip>
                                                </span>
                                            </div>}
                                            {(item?.vk && !item?.vkVnutr) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    <SettingOutlined style={{ color: "orange", fontSize: "12px", paddingRight: "3px" }} />
                                                    <Tooltip 
                                                    title={<div>
                                                        <div style={{
                                                            textAlign: "left",
                                                            textWrap: "nowrap",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            fontSize: "12px",
                                                            fontWeight: "lighter"
                                                        }}>
                                                            <span>Техническая информация</span>
                                                        </div>
                                                        <div>{item?.vk}</div>
                                                    </div>}>{replaceVk(item?.vk)}</Tooltip>
                                                </span>
                                            </div>}
                                            {(!item?.vk && item?.vkVnutr) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    <SettingOutlined style={{ color: "red", fontSize: "12px", paddingRight: "3px" }} />
                                                    <Tooltip 
                                                    title={<div>
                                                        <div style={{
                                                            textAlign: "left",
                                                            textWrap: "nowrap",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            fontSize: "12px",
                                                            fontWeight: "lighter"
                                                        }}>
                                                            <span>Техническая информация (внутр.)</span>
                                                        </div>
                                                        <div>{item?.vkVnutr}</div>
                                                    </div>}>{replaceVk(item?.vkVnutr)}</Tooltip>
                                                </span>
                                            </div>}

                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "130px", maxWidth: "130px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "center", height: "100%", minWidth: "130px", maxWidth: "130px" }}>
                                            {(!item?.user?.city && !item?.city && !item?.cityVnutr) && <div>
                                                <span style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>Нет</span>
                                            </div>}
                                            {(item?.user?.city) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    <UserOutlined style={{ color: "#1890ff", fontSize: "12px", paddingRight: "3px" }} />
                                                    <Tooltip
                                                        title={<div>
                                                            <div style={{
                                                                textAlign: "left",
                                                                textWrap: "nowrap",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                fontSize: "12px",
                                                                fontWeight: "lighter"
                                                            }}>
                                                                <span>Пользовательская информация</span>
                                                            </div>
                                                            <div>{item?.user?.city?.name}</div>
                                                        </div>}>{item?.user?.city?.name}</Tooltip>
                                                </span>
                                            </div>}
                                            {(item?.city && !item?.cityVnutr) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    <SettingOutlined style={{ color: "orange", fontSize: "12px", paddingRight: "3px" }} />
                                                    <Tooltip 
                                                    title={<div>
                                                        <div style={{
                                                            textAlign: "left",
                                                            textWrap: "nowrap",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            fontSize: "12px",
                                                            fontWeight: "lighter"
                                                        }}>
                                                            <span>Техническая информация</span>
                                                        </div>
                                                        <div>{item?.city?.name}</div>
                                                    </div>}>{item?.city?.name}</Tooltip>
                                                </span>
                                            </div>}
                                            {(!item?.city && item?.cityVnutr) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    <SettingOutlined style={{ color: "red", fontSize: "12px", paddingRight: "3px" }} />
                                                    <Tooltip 
                                                    title={<div>
                                                        <div style={{
                                                            textAlign: "left",
                                                            textWrap: "nowrap",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            fontSize: "12px",
                                                            fontWeight: "lighter"
                                                        }}>
                                                            <span>Техническая информация (внутр.)</span>
                                                        </div>
                                                        <div>{item?.cityVnutr?.name}</div>
                                                    </div>}>{item?.cityVnutr?.name}</Tooltip>
                                                </span>
                                            </div>}

                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
                                        <div className="bg bg-blue dark-1 border-transparent" style={{ textAlign: "left", height: "100%", minWidth: "250px", maxWidth: "250px" }}>
                                            {JSXMap(shkola, (obj, oidx) => (
                                                <div key={oidx}>
                                                    <div>{obj?.shkola?.nazvanieShkoliTantsev} ({obj?.shkola?.regionalnoeOtdelenie?.nazvanie})</div>
                                                    <div style={{
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        textAlign: "left",
                                                        textWrap: "nowrap",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        fontSize: "12px",
                                                        fontWeight: "lighter"
                                                    }}>
                                                        ({dayjs(obj?.shkola?.dataRegistratsii).format('DD.MM.YYYY')})
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ textAlign: "left", height: "100%", minWidth: "250px", maxWidth: "250px" }}>
                                            {JSXMap(organizator, (obj, oidx) => (
                                                <div key={oidx}>
                                                    <div>{obj?.organizator?.nazvanie} ({obj?.organizator?.regionalnoeOtdelenie?.nazvanie})</div>
                                                    <div style={{
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        textAlign: "left",
                                                        textWrap: "nowrap",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        fontSize: "12px",
                                                        fontWeight: "lighter"
                                                    }}>
                                                        ({dayjs(obj?.organizator?.dataRegistratsii).format('DD.MM.YYYY')})
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
                                        <div className="bg bg-green dark-1 border-transparent" style={{ textAlign: "left", height: "100%", minWidth: "250px", maxWidth: "250px" }}>
                                            {JSXMap(prepodavatel, (obj, oidx) => (
                                                <div key={oidx}>
                                                    <div>{obj?.prepodavatel?.regionalnoeOtdelenie?.nazvanie}</div>
                                                    <div style={{
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        textAlign: "left",
                                                        textWrap: "nowrap",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        fontSize: "12px",
                                                        fontWeight: "lighter"
                                                    }}>
                                                        ({dayjs(obj?.prepodavatel?.dataRegistratsii).format('DD.MM.YYYY')})
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
                                        <div className="bg bg-red dark-1 border-transparent" style={{ textAlign: "left", height: "100%", minWidth: "250px", maxWidth: "250px" }}>
                                            {JSXMap(sudya, (obj, oidx) => (
                                                <div key={oidx}>
                                                    <div>{obj?.sudya?.regionalnoeOtdelenie?.nazvanie}</div>
                                                    <div style={{
                                                        color: "rgba(0, 0, 0, 0.45)",
                                                        textAlign: "left",
                                                        textWrap: "nowrap",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        fontSize: "12px",
                                                        fontWeight: "lighter"
                                                    }}>
                                                        ({dayjs(obj?.sudya?.dataRegistratsii).format('DD.MM.YYYY')})
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "240px", maxWidth: "240px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "left", height: "100%", minWidth: "240px", maxWidth: "240px" }}>
                                            {item?.kommentarii}
                                        </div>
                                    </td>

                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin >
        </div >)
    }

    // const render = (_item, idx) => {
    //     console.log(_item);
    //     let item = _item?.user;
    //     return (<div key={item.ID || idx} style={{ width: "100%" }}>
    //         <div className={classes.item}>
    //             <div style={{ flex: "auto" }}>
    //                 <User item={item} />
    //                 {(_item?.city?.name || _item?.vk) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
    //                     <span>
    //                         <UserOutlined style={{ color: "#1890ff", fontSize: "10px", paddingRight: "3px" }} /> {_item?.city?.name && <span>{_item?.city?.name}</span>} {_item?.vk && <span>{_item?.vk}</span>}
    //                     </span>
    //                 </div>}
    //                 {(_item?.cityVnutr?.name || _item?.vkVnutr) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
    //                     <span>
    //                         <SettingOutlined style={{ color: "orange", fontSize: "10px", paddingRight: "3px" }} /> {_item?.cityVnutr?.name && <span>{_item?.cityVnutr?.name}</span>} {_item?.vkVnutr && <span>{_item?.vkVnutr}</span>}
    //                     </span>
    //                 </div>}
    //             </div>
    //         </div>
    //     </div>)
    // }

    return (
        <PageLayout>
            <Row gutter={[5, 5]} className="filtered-footer">
                <Col span={24}>
                    <Card size="small" bordered={false} className={classes.cardSmall}>
                        <CollectionServer
                            auth={auth}

                            floatingFilter={true}
                            disableScrollTo={true}
                            allowFullscreen={true}

                            name={"UserInfo"}
                            source={"/api/fed/admin/user-info/list"}
                            filters={filters}
                            size={"small"}
                            mode={"list"}
                            title="Тех. информация"

                            customRender={render}

                            // render={render}
                            collectionActions={() => [
                                {
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/fed/admin/user-info/new`, { ...values, userID: values?.user?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    form: AddUserInfo,
                                    title: "Новая информация",
                                    modal: {
                                        title: "Новая информация",
                                    }
                                },
                                {
                                    action: (values, unlock, close) => {
                                        close()
                                    },
                                    okText: "Готово",
                                    form: LoadUserInfo,
                                    title: <span><UploadOutlined /> Загрузка</span>,
                                    modal: {
                                        title: "Загрузка информации",
                                        width: "600px"
                                    },
                                    steps: [
                                        {
                                            key: "file",
                                            name: "Выбор файла",
                                            action: (values, unlock, close) => {
                                                POSTFormData(auth, `/api/fed/admin/user-info/import-xlsx`, makeFormData(values),
                                                    ({ errors }) => {
                                                        close({ errors: errors });
                                                    },
                                                    (err) => errorCatch(err, unlock));
                                            },
                                            form: LoadUserInfo,
                                            okText: "Загрузить"
                                        },
                                        {
                                            key: "log",
                                            name: "Результаты загрузки",
                                            noAntForm: true,
                                            okText: "Закрыть",
                                            form: (props) => {
                                                return (
                                                    <div style={{ maxHeight: "400px", overflowY: "scroll" }}>
                                                        <List
                                                            size="small"
                                                            bordered
                                                            dataSource={props?.data?.file?.errors}
                                                            renderItem={item => <List.Item>[{item.code}] {item.message}</List.Item>}
                                                        />
                                                    </div>
                                                )
                                            },
                                        }
                                    ]
                                }
                            ]}
                            modelActions={(item) => [
                                {
                                    title: "Изменить",
                                    modal: {
                                        // minWidth: "250px",
                                        title: "Изменить информацию",
                                    },
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/fed/admin/user-info/update`, { ...item, ...values, userID: values?.user?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    form: AddUserInfo,
                                    object: item,
                                    options: {
                                        initialValues: {
                                            ...item
                                        },
                                    },
                                },
                                {
                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        Modal.confirm({
                                            title: `Вы уверены что хотите удалить доп. информацию о пользователе?`,
                                            icon: <ExclamationCircleOutlined />,
                                            // content: <User item={item.vtp.user} noborder={true} />,
                                            okText: "Да",
                                            okType: 'danger',
                                            cancelText: "Нет",
                                            onOk: () => {
                                                GET(auth, `/api/fed/admin/user-info/delete/${item.ID}`,
                                                    () => setCollection(deleteInArray(collection, item)), errorCatch
                                                );
                                            },
                                        });

                                    },
                                }
                            ]}
                        />
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
